
import {getJSON, getJSONP, postForm} from './myaxios';
import {orderEvent, casherPV, click_event} from '../tools/mgtv/analysis'
import * as Cookie from 'tiny-cookie'
import {WX_OPEN_ID, IOS_PAY_PARAM_CACHE, RETURN_URL} from '../constant/CookieKeys'
import {compare_version} from '../tools/mgtv/version'
import channels from '../constant/channels'
import get_open_id from '../tools/mgtv/openid'

const channel_name = {
  '9D5A10B33BCD': 'alipay',
  'ZFB34XYB49X6': 'alipaysdk',
  'QA3R2TD56U12': 'alipay',
  '837D14E0B693': 'wechat',
  '1DF81F20CD7M': 'wechat',
  '2BU45R97JD7A': 'wechat',
  'J3C03EC0249B': 'jdpay',
  'JDDUT2018515': 'jdpay',
  'C127CA0D4C66': 'ccbpay',
  'EF5C7535A51M': 'cmbpay',
  'SCENE535A51T': 'cmbpaysdk',
};


/**
 * mgtv 向as系统下单并唤起支付
 * @param {*} params
 */
let allow_create_order = true;//下单间距2秒
function create_vip_order_api(params) {
  /**
   * http://wiki.imgo.tv/pages/viewpage.action?pageId=3758371#id-会员计费系统AS接口文档（forclient）-2.下单接口
   字段 含义 类型 是否必须 样例
   product_id    产品ID    int    是    10
   channel    支付渠道    string    是
   ticket    登录ticket    string    是
   */

  if (!allow_create_order) {
    console.error('下单过快')
    return new Promise(function (resolve, reject) {
      resolve(-99);
    });
  }

  allow_create_order = false;
  window.setTimeout(() => {
    allow_create_order = true;
  }, 5000);

  window.$toast.loading({
    mask: false,
    forbidClick: true, // 禁用背景点击
    message: '正在下单...',
    duration: 0
  });
  return getJSONP('//vipact3.api.mgtv.com/api/v1/union/mask/buy/v4', params);
};


function create_vip_order(product_id, channel_id, cp_info , voucher = null, phone_num = null, clocation = '1') {

  console.log('create_vip_order', product_id, channel_id,cp_info, voucher, phone_num, clocation)

  if (!channel_id) {
    console.error('没有选择渠道');　//没有渠道　返回
    return
  }
  if (!product_id) {
    console.error('没有选择产品');　//没有产品　返回
    return
  }


  let appVersion = window.$bus.device_info.appVersion;
  let mac = window.gact.analysis_id;

  //检查iphone版本，如果低于指定版本，需要给提示
  if (gact.is_app) {
    mac = window.$bus.device_info.did;
    //iphone检查版本
    if ((gact.is_iphone && compare_version('<', '5.7.4')) || (gact.is_ipad && compare_version('<', '5.7.2'))) {
      click_event('请升级芒果TV');
      window.$dialog.alert({
        message: '检测到您的版本过低，请升级到最新版本'
      }).then(() => {
        // on confirm
        //
      });
      return;
    }
  }

  //微信中获取open_id，如果没有open_id返回。open_id在进入页面时会获取
  let open_id;
  if (gact.is_wx && channel_id === 'wechat') {
    open_id = Cookie.get(WX_OPEN_ID);
    if (!open_id) {
      if (gact.debug) {
        open_id = 'ozjvTtz30rbEQpJ5asW8tv7VwcFY';
      } else {
        click_event('没有openid');
        get_open_id();
        return;
      }
    }
  }

  const order_param = {
    ...cp_info, //cp_uid ,cp_nickname
    ticket: window.$bus.user.ticket,
    version: appVersion,
    invoker: window.gact.order_invoker,
    os: window.gact.os,
    mac,
    t: new Date().getTime(),
    product_id: product_id,
    pay_channel: channel_id,
    voucher_id: voucher ? voucher.id : null,//代金券id,
    phone_num: phone_num,
    target_platform:  window.gact.order_invoker,
    target_version:  appVersion,
    target_devid: mac,
    scene_code: 'system',
    open_id: open_id,
    source_uuid: window.rootdata.act_name, //订单中记录下单来源
    act_name:window.rootdata.act_name //联合会员用来判断活动是否已经结束
  };


  if (gact.is_app && !gact.is_android) {
    //苹果下单
    //苹果支付特殊处理
    //查询凭据
    const is_vip_product =  true;
    console.log('检查凭据');
    if (window.gact.debug) { //测试，直接下单
      _create_order(product_id, clocation, order_param);
      return;
    }
    MgtvApi.checkReceipt({
      serviceType:product_id,
      videoId: is_vip_product ? '' : window.gact.source, // vip为空,单点填写视频id
      uuid: window.$bus.user.uuid
    }, function (resp) {
      console.log('checkReceipt', resp)
      if (resp.code === 200 && resp.data.result === 1) {
        //有未上传的凭据
        // resp.code 200: 表示成功
        // resp.result : 1表示本地存在未上传的凭据，0表示本地不存在未上传的凭据
        let param = Cookie.get(IOS_PAY_PARAM_CACHE);
        if (param) {
          param = JSON.parse(param);
          param.orderId = "";
        } else {
          param = {
            serviceType:product_id,
            productType: is_vip_product ? 'VIP' : 'Single',
            userId: window.$bus.user.uuid,
          }
        }
        console.log(param);
        MgtvApi.IAPAuth(param, function (resp) {
          if (resp.code === 200) {
            // 200: 表示支付成功
            window.location.reload();
          } else {
            click_event('IOS上传凭据失败');
          }
        });
      } else {
        _create_order(product_id, clocation, order_param);
      }
    });
  } else {


    if ( channel_id === 'wechat') {
      //微信js支付要声明下
      if(gact.is_wx){ //微信下
        order_param.channel_type = 'WXJS';
      }else if(!gact.is_app){ //非APP中
        order_param.channel_type = 'WXH5';
      }
    }
    _create_order(product_id, clocation, order_param);
  }
};


function _create_order(product_id, clocation, order_param) {
  create_vip_order_api(order_param).then(res => {

    allow_create_order = true;
    window.$toast.clear();
    console.log('下单返回值', res);

    if (!res) {
      return;
    }
    if (res === -99) {
      return;
    }

    if (res.status === '200') {

      //2019-02-15 这个返回值和V4下单有稍微区别，原有的res.data 被写到了res.msg中了
      res.data = res.msg;

      const pay_info = res.data.pay_info;
      const channel = pay_info.channel_code;
      const order_id = res.data.boid;
      // const product_id = product_id;
      const raw_price = res.data.pay_info.pay_amount / 100;
      orderEvent(clocation, product_id, raw_price, channel, order_id);
      const return_url = pay_info.return_url;
      const pay_msg = pay_info.pay_msg;


      //唤起支付
      if (gact.is_app) {
        if (gact.is_android) {


          //话费h5支付
          if (channel === channels.phone) {
            setTimeout(() => {
              window.location.href = pay_msg;
            }, 200);
            return;
          }

          const iapParams = {
            // 这个是活动统计那边的，有就传，没就留空
            pagename: '',
            actid: window.gact.source,
            clocation: clocation,
            p: product_id, // 产品包id
            pp: raw_price, // 价格
            c: channel, // 渠道号
            o: order_id, // 支付订单id,这里为了避免出现结果页使用的以noas-开头的业务订单
            videoId: '',
            iapType: '',
            payUrl: pay_info.pay_type === 'location' ? pay_info.pay_msg : '',
            sdkData: pay_info.pay_type === 'result' ? pay_info.pay_msg : '',
            t: channel_name[channel],
            expver: '',
            completed_url: return_url
          };

          if (channel === channels.ccb) {
            //建行sdk支付在5.5.1才支持
            if (compare_version('<', '5.5.1')) {
              setTimeout(() => {
                window.location.href = pay_msg;
              }, 200);
              return;
            } else {
              iapParams.sdkData = pay_msg.split('?')[1];
            }
          }

          const iapParamStr = JSON.stringify(iapParams)
          console.log('唤起支付', iapParamStr)
          MgtvApi.getIap(iapParams);

        } else {
          //苹果端支付
          //上报订单

          const api_params = {
            videoId: '',
            iapType: '',
            sourceType: '',
            productId: pay_info.charge_point,
            productIdNum: parseInt(product_id),
            productType: 'VIP',
            productPrice: raw_price,
            userId: window.$bus.user.uuid,
            code: channel,
            expver: '',
            orderId: order_id,
            serviceType:product_id,

          };

          Cookie.set(IOS_PAY_PARAM_CACHE, JSON.stringify(api_params));
          console.log(JSON.stringify(api_params));

          MgtvApi.IAPAuth(api_params, function (resp) {
            if (resp.code === 200) {

              // 200: 表示支付成功
              //window.location.reload();
              setTimeout(() => {
                MgtvApi.jumpPage({
                  url: return_url
                });
              }, 1000);
            } else {
              click_event('IOS支付失败');
            }
          });

        }
      } else {
        //20180806为了让微信代扣出现购买完成页
        if (window.gact.is_wx && channel === "2BU45R97JD7A") {
          Cookie.set(RETURN_URL, return_url, {expires: "5m"}); //main.js中做跳转 ，有from_wxpay=1表示从代扣页面回来的。
        }

        setTimeout(() => {
          if (channel === channels.wechat.js) {//微信支付
            WXJSPay(pay_info);
            // window.localStorage.setItem('usercenter_order', pay_info.pay_msg);
            // window.location.href = "//club.mgtv.com/usercenter/wxpay.html?return_url=" + encodeURIComponent(return_url);
          } else if (channel === channels.alipay.renew) { //支付宝连续包月
            window.location.href = "https://d.alipay.com/i/index.htm?iframeSrc=" + window.encodeURIComponent("alipays://platformapi/startapp?appId=20000067&url=" + window.encodeURIComponent(pay_info.pay_msg))
            //  window.location.href = 'alipays://platformapi/startapp?appId=20000067&url=' + window.encodeURIComponent(pay_info.pay_msg);
          } else {
            window.location.href = pay_info.pay_msg;
          }
        }, 200);
      }
    } else {
      window.$toast(res.msg)
    }
  })
}


//直接在本页面进行支付
function WXJSPay(pay_info) {
  const onBridgeReady = __WXJSPay.bind(null, pay_info);
  if (typeof WeixinJSBridge === "undefined") {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
    }
  } else {
    onBridgeReady();
  }
}


function __WXJSPay(pay_info) {
  const wxpay_msg = JSON.parse(pay_info.pay_msg);
  const return_url = pay_info.return_url;
  //唤起微信支付 js api
  WeixinJSBridge.invoke('getBrandWCPayRequest', wxpay_msg, function (response) {
    if (response.err_msg === "get_brand_wcpay_request:ok") {
      window.location.href = return_url;
    }
  });
}







export default function buyUnionVip(action_info) {

  //对action_info的一些${NAME},${VIP}进行处理



  //先拉起一个填写合作方账号的弹窗，再进行校验，再去支付
  window.$bus.$union_input_modal.show({
    action_info
  }).then(isUsernameValid).then(cp_info => {
    console.log('cp_info', cp_info)
    if (!cp_info) {
      //显示支付弹窗，选择支付方式，->进行支付
      return
    }

    window.$union_pay_modal.show({
      action_info,
      cp_info
    }).then(res => {
      create_vip_order( action_info.product_id, res.channel,cp_info)
    }).catch(e => {

    })

  })
}


export function isUsernameValid(cp_nickname) {
  window.$toast.loading({
    mask: false,
    forbidClick: true, // 禁用背景点击
    message: '请稍后...',
    duration: 0
  });
  return getJSON('//vipact3.api.mgtv.com/api/v1/union/check', {
    ticket: window.$bus.user.ticket,
    act_name: window.rootdata.act_name,
    cp_nickname: cp_nickname
  }).then(res => {
    window.$toast.clear();
    if (!res) {
      return false;
    }
    if (res.ret === 0) {
      return {
        cp_uid: res.data.cp_uid || cp_nickname,
        cp_nickname: cp_nickname
      }
    } else {
      window.$toast(res.msg);
    }
    return null;
  })
}




// WEBPACK FOOTER //
// ./src/api/unionVip.js